var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceBookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5946 11.4436L15.1427 7.90618H11.7667V5.60683C11.7667 4.63955 12.238 3.69438 13.7451 3.69438H15.3016V0.682009C14.3952 0.535172 13.4793 0.455734 12.5614 0.444336C9.78275 0.444336 7.96871 2.14121 7.96871 5.20886V7.90618H4.88867V11.4436H7.96871V19.9999H11.7667V11.4436H14.5946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBookIcon);
export default __webpack_public_path__ + "static/media/faceBookIcon.3097937da97ebbac8edad3d64f68d973.svg";
export { ForwardRef as ReactComponent };